<script>
export default {
  name: 'Badge',
  props: {
    badge: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<template>
  <v-chip
    class="ma-0"
    :color="badge.color"
    :text-color="badge.text"
    :small="small"
  >
    {{ title ? title : $t(`badges.${badge.label}`) }}
  </v-chip>
</template>



// WEBPACK FOOTER //
// src/components/Badge.vue